(function () {
  if (window.location.pathname !== '/cart') return;

  function money(cents) {
    var amount = cents / 100;
    try {
      return amount.toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD',
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      });
    } catch (error) {
      return '$' + (amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2));
    }
  }

  function goBack(event) {
    event.preventDefault();
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    window.location.href = '/collections/all';
  }

  function ensureBackButton() {
    var header = document.querySelector('.fh-cart__header');
    if (!header || header.querySelector('[data-cart-return], .fh-cart-back-btn')) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'fh-cart-back-btn';
    button.innerHTML = '<span aria-hidden="true">←</span><span>Back to previous page</span>';
    button.addEventListener('click', goBack);
    header.appendChild(button);
  }

  function ensureFreeShipping() {
    var cart = document.querySelector('.fh-cart');
    var form = document.querySelector('.fh-cart__form');
    if (!cart || !form || cart.querySelector('.fh-cart-free-shipping--top')) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cartJson) {
        if (!cartJson.item_count) return;

        var threshold = 8900;
        var remaining = Math.max(0, threshold - cartJson.total_price);
        var progress = threshold > 0 ? Math.min(100, Math.round((cartJson.total_price / threshold) * 100)) : 100;
        var wrapper = document.createElement('div');
        var message = document.createElement('p');
        var track = document.createElement('span');
        var fill = document.createElement('span');

        wrapper.className = 'fh-cart-free-shipping fh-cart-free-shipping--top';
        wrapper.setAttribute('aria-label', 'Free shipping status');
        wrapper.setAttribute('role', 'status');
        message.className = remaining <= 0 ? 'fh-cart-free-shipping__message fh-cart-free-shipping__message--unlocked' : 'fh-cart-free-shipping__message';
        message.textContent = remaining <= 0 ? 'Free shipping unlocked' : money(remaining) + ' away from free shipping';
        track.className = 'fh-cart-free-shipping__track';
        track.setAttribute('role', 'progressbar');
        track.setAttribute('aria-label', 'Free shipping progress');
        track.setAttribute('aria-valuemin', '0');
        track.setAttribute('aria-valuemax', '100');
        track.setAttribute('aria-valuenow', String(progress));
        fill.style.width = progress + '%';

        track.appendChild(fill);
        wrapper.appendChild(message);
        wrapper.appendChild(track);
        form.parentNode.insertBefore(wrapper, form);
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    ensureBackButton();
    ensureFreeShipping();
    document.querySelectorAll('[data-cart-return]').forEach(function (button) {
      button.addEventListener('click', goBack);
    });
  });
}());
